<script setup lang="ts">
import { type Address } from '@models/address.ts';
import Typography from '@components/Typography.vue';
import { useStreetDistrict } from '@composables/useStreetDistrict.ts';

const props = defineProps<{ address: Address }>();

const { formattedStreetDistrict } = useStreetDistrict(props.address);
</script>

<template>
  <Typography
    as="span"
    variant="body-bold"
    class="offer-card__title"
  >
    {{ formattedStreetDistrict }}
  </Typography>
</template>
